import instance from '../axios';

export const getSalesList = async () => {
  const response = await instance.get(`smd/get-sales-by-supervisor`);
  return response.data;
};

export const getStoreById = async (id) => {
  const response = await instance.get(`smd/get-store-by-id?id=${id}`);
  return response.data;
};

export const getProvById = async (id) => {
  const response = await instance.get(`smd/get-prov-by-id?id=${id}`);
  return response.data;
};

export const getCityById = async (id) => {
  const response = await instance.get(`smd/get-city-by-id?id=${id}`);
  return response.data;
};

// New endpoints for SMD -> Province -> City flow
export const getProvincesBySMD = async (sales_id) => {
  const response = await instance.get(`smd/get-provinces-by-sales?sales_id=${sales_id}`);
  return response.data;
};

export const getCitiesBySMDAndProvince = async (sales_id, prov_id) => {
  const response = await instance.get(`smd/get-cities-by-sales-and-province?sales_id=${sales_id}&province_id=${prov_id}`);
  return response.data;
};
